const Test = () => {
    return (
        <div className="flex h-screen w-screen justify-center mt-10">
            <iframe 
                src="http://localhost:5173/StatsConsole/en_GB/minimized?theme=light&fixtures=true&eventId=0" 
                width="702px" 
                height="682px"
            ></iframe>
        </div>
    )
}

export default Test;